"use client";

interface SystemComplexityProps {
    data:{
        itemsList: {
            description: string;
            title?: string; 
        }[];
        conclusionText?: string;
    }
}
const SystemComplexity = ({ data }: SystemComplexityProps) => {

  return (
    <div className="flex justify-center max-sm:px-5">
    <div className="max-w-6xl w-full mx-4 pb-10">

      {/* List Items */}
      <div className="space-y-4 mb-8">
        {data.itemsList.map((item, index) => (
          <div 
            key={index}
            className="flex flex-col sm:flex-row items-start gap-8 bg-white rounded-lg py-4 duration-200"
          >
            {/* Icon/Letter */}
            <div className="flex-shrink-0">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-500 text-white flex items-center justify-center font-bold text-lg sm:text-xl">
                {item.title}
              </div>
            </div>
            
            {/* Description */}
            <div className="flex-1 min-w-0">
              <p className="text-gray-700 text-xl leading-relaxed break-words">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Conclusion Banner */}
      {data.conclusionText && (
        <div className="bg-green-600 text-white rounded-lg p-4 sm:p-6">
          <p className="text-base text-xl font-medium text-center leading-relaxed">
            {data.conclusionText}
          </p>
        </div>
      )}
    </div>
    </div>
  );
};

export default SystemComplexity;